import classNames from 'classnames';
import React, { useCallback } from 'react';
import { Counter, CounterSize, ImageLoadingBehaviorOptions, ImageResizeOptions as TPAImageResizeOptions, Text as TPAText, TextPriority, ThumbnailImage } from '@wix/wix-ui-tpa/cssVars';
import { useConfig } from '../../../contexts/config-context';
import { ImageResizeOptions } from '../../../field-settings/settings-shared/image/types';
import { classes, st } from './product-wut.st.css';
import { getCurrencyAriaLabel } from '../../shared/payment-field-utils';
import { useTranslation } from '../../../contexts/translation-context';
import { formatCurrency } from '../../../utils/format-currency';
const toTPAImageResize = {
  [ImageResizeOptions.crop]: TPAImageResizeOptions.cover,
  [ImageResizeOptions.fit]: TPAImageResizeOptions.contain
};
export const ProductWUT = _ref => {
  var _item$media, _item$media2;
  let {
    item,
    imageResize,
    onQuantityChange,
    price = 0,
    hasError,
    quantity = 0
  } = _ref;
  const {
    currency,
    regionalFormat
  } = useConfig();
  const {
    t
  } = useTranslation();
  const formattedPrice = formatCurrency({
    amount: price,
    currency: currency == null ? void 0 : currency.code,
    locale: regionalFormat
  });
  const currencyTranslation = getCurrencyAriaLabel(t, currency);
  const ariaLabel = `${item.label} ${currencyTranslation} ${price}`;
  const imageAlt = ((_item$media = item.media) == null || (_item$media = _item$media.image) == null ? void 0 : _item$media.altText) || item.label || '';
  const setQuantity = useCallback(value => {
    onQuantityChange == null || onQuantityChange(value < 0 ? 0 : value);
  }, [onQuantityChange]);
  const onKeyDown = useCallback(event => {
    if (event.key === 'Home') {
      event.preventDefault();
      setQuantity(0);
    }
  }, [setQuantity]);
  return /*#__PURE__*/React.createElement("div", {
    className: st(classes.root),
    "data-hook": "product"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.main
  }, (_item$media2 = item.media) != null && _item$media2.image ? /*#__PURE__*/React.createElement("div", {
    className: classes.image
  }, /*#__PURE__*/React.createElement(ThumbnailImage, {
    aspectRatio: "square",
    height: 96,
    width: 96,
    loadingBehavior: ImageLoadingBehaviorOptions.blur,
    resize: toTPAImageResize[imageResize],
    sourceHeight: item.media.image.height,
    sourceWidth: item.media.image.width,
    src: item.media.image.id,
    stretchImage: true,
    alt: imageAlt
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.info
  }, /*#__PURE__*/React.createElement(TPAText, {
    "data-hook": "product-label",
    className: classes.productName,
    priority: item.label ? TextPriority.primary : TextPriority.secondary
  }, item.label || ''), /*#__PURE__*/React.createElement(TPAText, {
    "data-hook": "product-price",
    className: classes.productPrice,
    priority: price !== undefined ? TextPriority.primary : TextPriority.secondary
  }, formattedPrice))), onQuantityChange ? /*#__PURE__*/React.createElement(Counter, {
    "data-hook": "product-quantity",
    className: classNames(classes.counter, classes.theme, {
      [classes.error]: hasError
    }),
    inputAriaLabel: ariaLabel,
    size: CounterSize.xSmall,
    step: 1,
    min: 0,
    value: quantity,
    onChange: val => {
      setQuantity(Number(val));
    },
    error: hasError,
    steppersType: "button",
    onKeyDown: onKeyDown
  }) : null);
};
//# sourceMappingURL=product-wut.js.map